import type { PortfolioIssue } from '~/services/generated/client';

export default defineNuxtPlugin({
  name: 'gtmUserData',
  parallel: true,

  setup() {
    const { investorProfileApi, investorPortfolioApi } = useApi();

    const dayjs = useDayjs();

    const gtm = useGtm();

    const userState = useUserState();

    watch(userState, async (newUser, oldUser) => {
      const isSameUser = isEqual(newUser, oldUser);

      if (userState.value && !isSameUser) {
        const portfolio = await investorPortfolioApi.value.getInvestorPortfolio({ xCFGINVESTORUSERID: userState.value?.sub || '' });
        const investorProfile = await investorProfileApi.value.getInvestorProfile({ xCFGINVESTORUSERID: userState.value?.sub || '' });

        const activeIssues = portfolio.companies.reduce((acc: PortfolioIssue[], company) => {
          acc.push(...company.portfolioIssues.filter((issue) => dayjs().isSameOrBefore(issue.maturityDate)));

          return acc;
        }, [] satisfies PortfolioIssue[]) || [];

        gtm?.push({ event: 'set_user_data', user_id: investorProfile.id, active_issues: activeIssues?.length });
      }
    }, { deep: true });
  }
});
